import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GPTGameNameType } from '../games/types';
import { GAMES_CONFIG } from '../games/config';
import dayjs from 'dayjs';

type GPTBannerStore<TGameNames extends string | number | symbol = GPTGameNameType> = Record<
  TGameNames,
  boolean
> & {
  showBanner: (gameName: TGameNames) => void;
  hideBanner: (gameName: TGameNames) => void;
  closeTime: string;
  showAllBanners: () => void;
};

export const useGPTBanner = create<GPTBannerStore>()(
  persist(
    (set) => {
      return {
        ...makeBannersDefaultState(),
        showBanner: (gameName) => set({ [gameName]: true }),
        hideBanner: (gameName) => set({ [gameName]: false, closeTime: today() }),
        closeTime: yesterday(),
        showAllBanners: () => set({ ...makeBannersDefaultState(), closeTime: today() })
      };
    },
    {
      name: 'gptBannersState'
    }
  )
);

function makeBannersDefaultState() {
  return Object.keys(GAMES_CONFIG).reduce(
    (result, game) => ({ ...result, [game]: true }),
    {} as Record<GPTGameNameType, boolean>
  );
}

function today() {
  return dayjs().format('DD.MM');
}

function yesterday() {
  return dayjs().subtract(1, 'day').format('DD.MM');
}
